import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Sprout, LogOut, Settings2, LayoutGrid } from "lucide-react";

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const doLogout = async () => {
    await logout();
    nav("/login");
  };

  const linkBase =
    "inline-flex items-center gap-2 px-3 py-2 text-sm rounded-md hover:bg-secondary/70";
  const active = ({ isActive }) =>
    `${linkBase} ${isActive ? "bg-secondary text-primary font-semibold" : "text-foreground/80"}`;

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-border bg-card">
        <div className="mx-auto max-w-7xl px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
            <span className="h-9 w-9 rounded-md bg-primary text-primary-foreground flex items-center justify-center">
              <Sprout className="h-5 w-5" />
            </span>
            <div className="leading-tight">
              <div className="font-display font-bold text-primary">PRONAF Projects</div>
              <div className="text-[11px] text-muted-foreground tracking-wide uppercase">
                Gerador de projetos Grupo A - Investimento
              </div>
            </div>
          </Link>

          <nav className="flex items-center gap-1">
            <NavLink to="/dashboard" className={active} data-testid="nav-dashboard">
              <LayoutGrid className="h-4 w-4" /> Projetos
            </NavLink>
            <NavLink to="/settings" className={active} data-testid="nav-settings">
              <Settings2 className="h-4 w-4" /> Configurações
            </NavLink>
            <div className="h-6 w-px bg-border mx-2" />
            <div className="hidden md:block text-sm text-muted-foreground mr-2" data-testid="current-user">
              {user?.name || user?.email}
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={doLogout}
              data-testid="logout-button"
            >
              <LogOut className="h-4 w-4 mr-1" /> Sair
            </Button>
          </nav>
        </div>
      </header>
      <main className="flex-1">{children}</main>
    </div>
  );
}
